<template>
  <div
    :class="_class"
    @click="onClick"
    ref="option"
    v-on="$listeners"
  >
    <ten-checkbox
      class="ten-option__check"
      v-if="_showCheckbox"
      :checked="selected"
      :disabled="disabled"
      :indeterminate="indeterminate"
      @change="onSelect"
      @click.stop
    />
    <ten-radio
      class="ten-option__check"
      v-else-if="_showRadio"
      :checked="selected"
      :disabled="disabled"
      @change="onSelect"
      @click.stop
    />
    <span class="ten-option__content">
      <slot />
    </span>
    <ten-icon
      class="ten-option__suffix-icon"
      v-if="_suffixIcon"
      :icon="_suffixIcon"
    />
  </div>
</template>
<script>
import TenCheckbox from '../checkbox';
import TenRadio from '../radio';
import TenIcon from '../icon';

const name = 'ten-option';
export default {
  name,
  components: { TenCheckbox, TenRadio, TenIcon },
  inject: ['tenOptions'],
  props: {
    selected: Boolean,
    active: Boolean,
    indeterminate: Boolean,
    disabled: Boolean,
    loading: Boolean,
    showCheckbox: Boolean,
    showRadio: Boolean,
    suffixIcon: String,
    optionIndex: Number,
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    _class() {
      return [
        'ten-option',
        {
          'ten-option--selected': this.selected,
          'ten-option--active': this.active,
          'ten-option--focused': this._focused,
          'ten-option--disabled': this.disabled,
          // 'ten-option--focused': this.tenOptions.focusIndex === this.index,
          'ten-option--visible': this.visible,
        },
      ];
    },
    _multiple() {
      return this.tenOptions.multiple;
    },
    _showCheckbox() {
      return 'showCheckbox' in this.$vnode.componentOptions.propsData
        ? this.showCheckbox
        : this.tenOptions.showCheckbox;
    },
    _showRadio() {
      return 'showRadio' in this.$vnode.componentOptions.propsData
        ? this.showRadio
        : this.tenOptions.showRadio;
    },
    _focused() {
      return this.tenOptions.focused && this.focused;
    },
    _suffixIcon() {
      if (this.loading) {
        return 'loading_gradient';
      }
      return this.suffixIcon;
    },
  },
  watch: {
    focused(v, ov) {
      if (v && !ov) {
        this.$emit('optionFocus');
      }
    },
  },
  mounted() {
    this.tenOptions.addOption(this);
  },
  beforeDestroy() {
    this.tenOptions.removeOption(this);
  },
  methods: {
    focus() {
      this.focused = true;
    },
    blur() {
      this.focused = false;
    },
    onClick() {
      if (this.disabled) {
        return;
      }
      this.$emit('optionClick');
      this.tenOptions.$emit('focusOptionChange', this);
    },
    onSelect() {
      this.$emit('select');
    },
    onKeyDown(e) {
      const { keyCode } = e;
      switch (keyCode) {
        case 13:
          this.$emit('optionKeyCommand', 'enter');
          break;
        case 37: // left
          this.$emit('optionKeyCommand', 'left');

          break;
        case 39: // right
          this.$emit('optionKeyCommand', 'right');
          break;
        default:
          break;
      }
    },
  },
};
</script>
